import styled from 'styled-components'
import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca'
import { leagueIds, ratePlanCodes, sportIds } from 'src/constants'
import {
  canadaPlanData,
  canadaSports_EPL_UCL_Override,
} from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-dazn.png"
        video="https://assets-imgx.fubo.tv/marketing/lp/videos/compressed/CA_DAZN_UEFA_16x9_10s_3Mb.mp4"
        videoMobile="https://assets-imgx.fubo.tv/marketing/lp/videos/mobile/CA_DAZN_UEFA_1x1_10s_3Mb.mp4"
        title="Watch every Champions League match"
        subtitle="Stream every UEFA Champions League match live on DAZN with Fubo"
        offerCode={ratePlanCodes.canada_sports_pro_mo}
        hasPlanCardsTabs={true}
        forceAnchorLink={false}
        networkSet="canada_dazn"
        planCardsConfig={{
          plans: [canadaPlanData.sports_pro],
          activeTab: 'monthly',
          overrides: canadaSports_EPL_UCL_Override,
        }}
        channelPlanCode={ratePlanCodes.canada_sports_pro_mo}
        networkHeadline="Stream the sports you love without cable"
        additionalFAQs={additionalFAQs}
        platformImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/ca-devices-2025.png"
        matchtickerSportId={sportIds.Soccer}
        matchtickerLeagueName="UEFA Champions League"
        matchtickerLeagueId={leagueIds.UCL}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .planCard .planCard__content .planCard__header .planCard__price {
    flex-wrap: wrap !important;
  }
`

const additionalFAQs = []
